var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05598 7.05798C6.53499 7.5786 6.53469 8.42299 7.05531 8.94398C7.57593 9.46497 8.42032 9.46527 8.94131 8.94465",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03591 2.85555C5.63767 2.96947 5.40719 3.38466 5.52111 3.7829C5.63503 4.18114 6.05022 4.41162 6.44846 4.2977L6.03591 2.85555ZM8.00019 3.33329L7.99753 4.08329H8.00019V3.33329ZM14.6669 7.99996L15.318 8.37217C15.4498 8.14157 15.4498 7.85845 15.318 7.62784L14.6669 7.99996ZM12.4474 9.81622C12.1663 10.1204 12.1849 10.5949 12.4891 10.8761C12.7933 11.1572 13.2678 11.1385 13.549 10.8344L12.4474 9.81622ZM11.9909 12.1878C12.3343 11.9561 12.4249 11.49 12.1933 11.1466C11.9617 10.8032 11.4955 10.7125 11.1521 10.9442L11.9909 12.1878ZM1.3335 7.99996L0.682364 7.62777C0.550555 7.85836 0.550539 8.14147 0.682322 8.37208L1.3335 7.99996ZM4.84251 5.05997C5.1853 4.82746 5.2747 4.36107 5.04218 4.01828C4.80966 3.67548 4.34328 3.58609 4.00048 3.81861L4.84251 5.05997ZM6.44846 4.2977C6.95214 4.15362 7.47365 4.08143 7.99753 4.08329L8.00284 2.5833C7.33765 2.58094 6.67546 2.6726 6.03591 2.85555L6.44846 4.2977ZM8.00019 4.08329C10.3068 4.08329 12.319 5.40305 14.0157 8.37208L15.318 7.62784C13.4587 4.3742 11.0269 2.58329 8.00019 2.58329V4.08329ZM14.0157 7.62775C13.5198 8.49524 12.9962 9.22252 12.4474 9.81622L13.549 10.8344C14.1882 10.1427 14.7765 9.31934 15.318 8.37217L14.0157 7.62775ZM11.1521 10.9442C10.1866 11.5954 9.14286 11.9166 8.00016 11.9166V13.4166C9.4468 13.4166 10.7817 13.0032 11.9909 12.1878L11.1521 10.9442ZM8.00016 11.9166C5.69351 11.9166 3.68135 10.5969 1.98467 7.62784L0.682322 8.37208C2.54165 11.6257 4.97349 13.4166 8.00016 13.4166V11.9166ZM1.98463 8.37215C2.8583 6.8437 3.81689 5.75565 4.84251 5.05997L4.00048 3.81861C2.73411 4.67759 1.63403 5.96288 0.682364 7.62777L1.98463 8.37215Z",
    fill: "#2F2B3D",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.24b9fc8fe96b08060c0233f2bb937107.svg";
export { ForwardRef as ReactComponent };